import {InMemoryCache} from "apollo-cache-inmemory";

let cache
if (!cache) {
  cache = new InMemoryCache({})
  cache.writeData({data:{loggedIn: false}})
}

export const CACHE = cache
